import React, { Suspense, FC } from 'react';
import ReactDOM from 'react-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import * as serviceWorker from './serviceWorker';
import { AppRoutes } from './router';
import { PureAntdLoading } from './ui/pure-antd-loading';
import { Login } from './view/login';
import { useAccountState } from './store/account';
import { StoreProvider } from './store';

import 'antd/dist/antd.less';
import './index.less';
import './style/iconfont/iconfont.less';
import './style/font/font.less';
import './antd-overrides.less';

const App: FC = () => {
  const [{ loading, ready, data: accountInfo }] = useAccountState();

  if (loading) {
    return <PureAntdLoading size="large" tip="正在获取账号信息" />;
  }

  if (!ready) return null;

  if (!accountInfo) {
    // 未登录，故没有用户信息
    return <Login />;
  }

  return (
    <Suspense fallback={<>Page Loading...</>}>
      <AppRoutes />
    </Suspense>
  );
};

ReactDOM.render(
  <DndProvider backend={HTML5Backend}>
    <StoreProvider>
      <App />
    </StoreProvider>
  </DndProvider>,
  document.getElementById('root')
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
